import React from "react"

function AccordionIcon() {
  return (
    <svg
      width="34px"
      height="33px"
      viewBox="0 0 34 33"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="square"
      >
        <g
          id="1.0-Homepage"
          transform="translate(-1359.000000, -1048.000000)"
          fillRule="nonzero"
          stroke="currentColor"
        >
          <g id="Group-8" transform="translate(1359.000000, 1048.000000)">
            <line
              x1="-4.58726415"
              y1="16.875"
              x2="38.75"
              y2="16.3888889"
              id="Line-Copy-18"
              transform="translate(16.875000, 16.388889) rotate(-45.000000) translate(-16.875000, -16.388889) "
            ></line>
            <line
              x1="17.1180556"
              y1="37.7777778"
              x2="16.6319444"
              y2="-5"
              id="Line-Copy-18"
              transform="translate(16.875000, 16.388889) rotate(-45.000000) translate(-16.875000, -16.388889) "
            ></line>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default AccordionIcon
